import type {UsersMeClipsResponse} from './clip/schema';

export function validateClips(
  content: UsersMeClipsResponse['clips'] | undefined,
): UsersMeClipsResponse['clips'] {
  if (!content) {
    return [];
  }

  return content;
}

export function clipsEntity(
  clips?: UsersMeClipsResponse['clips'],
): UsersMeClipsResponse['clips'] {
  const checkedClips = validateClips(clips);
  return checkedClips;
}
